import { useEffect, useState } from "react";
import PostBoxBody from "./post_box_body";
import PostBoxContent from "./post_box_content";
import PostBoxFooter from "./post_box_footer";
import PostBoxHeader from "./post_box_header";
import EditPostModal from "./edit_post";
import { SavePostView } from "../../apis/posts/save_post_view";
import MediaRender from "./MediaRender";

export default function PostBox({ item, esave,setEdit,setEditItem,vmute,setVmute }) {
    const [showLike, setShowLike] = useState(1);
    const [showShare, setShowShare] = useState(1);
    const [showPost, setShowPost] = useState(1);
    


    return <div>
        {
            showPost === 1 &&
            <div className="bg-white rounded-xl shadow-sm text-sm font-medium border1 dark:bg-dark2">
                <PostBoxHeader
                    item={item}
                    esave={esave}
                    setShowLike={setShowLike}
                    setShowShare={setShowShare}
                    setShowPost={setShowPost}
                    showLike={showLike}
                    showShare={showShare}
                    setEdit={setEdit}
                    setEditItem={setEditItem} />

                <MediaRender item={item} setVmute={setVmute} vmute={vmute} />


                <PostBoxFooter
                    item={item}
                    showLike={showLike}
                    showShare={showShare} />

                <PostBoxContent item={item} />
            </div>
        }
    </div>
}